<template>
  <v-container fluid class="pa-2">
    <v-row dense>
      <v-col cols="12" md="6">
        <v-card outlined class="flex-grow-1">
          <v-card-title
            class="grey lighten-4 font-weight-bold text-uppercase color-custom-blue"
          >
            Checklist Information
          </v-card-title>

          <v-card-text class="py-2">
            <table width="100%">
              <tr>
                <td
                  class="font-size-18 font-weight-500 py-1"
                  style="width: 120px"
                >
                  Title
                </td>
                <td class="font-size-18 py-1">
                  <template v-if="checklist && checklist.title">
                    <span class="text-capitalize">{{ checklist.title }}</span>
                  </template>
                  <template v-else> no Title </template>
                </td>
              </tr>
              <tr v-if="!isContract">
                <td
                  class="font-size-18 font-weight-500 py-1"
                  style="width: 120px"
                >
                  Equipment Count
                </td>
                <td class="font-size-18 py-1">
                  <template v-if="assignedEquipmentCount > 0">
                    {{ assignedEquipmentCount }}
                  </template>
                  <template v-else> no Equipment Count </template>
                </td>
              </tr>
              <tr>
                <td
                  valign="top"
                  class="font-size-18 font-weight-500 py-1"
                  style="width: 150px"
                >
                  Description
                </td>
                <td class="font-size-18 py-1">
                  <template v-if="checklist && checklist.description">
                    <span class="text-capitalize">{{
                      checklist.description
                    }}</span>
                  </template>
                  <template v-else> no Description </template>
                </td>
              </tr>
              <tr>
                <td
                  class="font-size-18 font-weight-500 py-1"
                  style="width: 120px"
                >
                  Added By
                </td>
                <td class="font-size-18 py-1">
                  <template
                    v-if="
                      checklist &&
                      checklist.added_by &&
                      checklist.added_by.display_name
                    "
                  >
                    <span class="text-capitalize">{{
                      checklist.added_by.display_name
                    }}</span>
                  </template>
                  <template v-else> no Added By </template>
                </td>
              </tr>
              <tr>
                <td
                  class="font-size-18 font-weight-500 py-1"
                  style="width: 120px"
                >
                  Added At
                </td>
                <td class="font-size-18 py-1">
                  <template v-if="checklist && checklist.added_at">
                    {{ formatDate(checklist.added_at) }}
                  </template>
                  <template v-else>
                    <em class="text-muted"> no Added At </em>
                  </template>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card outlined class="flex-grow-1 d-flex flex-column">
          <v-card-title
            class="grey lighten-4 font-weight-bold text-uppercase color-custom-blue"
          >
            Checklist Preview
          </v-card-title>

          <perfect-scrollbar
            class="checklist-preview-scroll"
            :options="{ suppressScrollX: true }"
          >
            <div class="checklist-preview-content">
              <div class="builderFormWrapperView">
                <div class="form-drag-container builderFormWrapper">
                  <div
                    v-for="(element, index) in formattedChecklistData"
                    :key="`checklist-${index}`"
                  >
                    <div class="form-fields py-5" v-if="element">
                      <div class="form-grp px-3">
                        <label
                          class="fw-500"
                          v-if="element && !element.hidelabel"
                          >{{ element.label }}</label
                        >
                        <template>
                          <v-row>
                            <v-col
                              :md="element.column"
                              v-for="(choice, choiceIndex) in element.choices"
                              :key="`choice-${choiceIndex}`"
                            >
                              <v-checkbox
                                hide-details
                                dense
                                disabled
                                v-model="choice.check_status"
                                :label="choice.label"
                                class="mt-0 pt-0"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </template>
                        <p
                          class="text-muted mt-2 mb-0"
                          v-if="element && element.instructions != null"
                        >
                          {{ element.instructions }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <v-alert
              v-if="!formattedChecklistData.length"
              dense
              type="info"
              text
              class="ma-0"
            >
              No checklist assigned
            </v-alert>
          </perfect-scrollbar>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import CommonMixin from "@/core/plugins/common-mixin";

export default {
  name: "EquipmentChecklist",
  title: "Equipment Checklist",
  mixins: [CommonMixin],

  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
    isContract: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    checklist() {
      return this.detail?.checklist || {};
    },

    assignedEquipmentCount() {
      if (
        this.checklist &&
        this.checklist.id &&
        this.detail &&
        this.detail.equipments
      ) {
        return this.detail.equipments.filter(
          (equipment) => equipment.checklist == this.checklist.id
        ).length;
      }
      return 0;
    },

    formattedChecklistData() {
      if (!this.checklist.checklist_data) {
        return [];
      }

      return this.checklist.checklist_data.map((item) => ({
        type: this.getFieldType(item.choices),
        label: item.label,
        required: item.validation_mandatory || false,
        choices: item.choices || [],
        instructions: item.instructions || null,
        column: item.column || null,
      }));
    },
  },

  methods: {
    getFieldType(choices) {
      if (!Array.isArray(choices) || choices.length === 0) {
        return "text";
      }
      return choices.length <= 3 ? "radio" : "select";
    },

    formatDate(date) {
      return date;
    },
  },
};
</script>
<style scoped>
.checklist-preview-scroll {
  background: #f5f7fb;
  max-height: 65vh;
  padding: 8px;
}

.checklist-preview-content {
  background: #fff;
  border-radius: 4px;
}

.form-fields {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.form-grp {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.v-input--checkbox {
  margin-top: 0 !important;
}
</style>
